// extracted by mini-css-extract-plugin
module.exports = {"Root":"LinkButton_Root__1EYpq"};